import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewExtractionSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewExtractionSubscription = { __typename?: 'subscription_root', plan_review_requirement_extractions_by_pk?: { __typename?: 'plan_review_requirement_extractions', id: any, jurisdiction_id: any, status: string, instructions?: string | null, candidate_count: number, imported_count: number, error_message?: string | null, model_name?: string | null, created_at: any, completed_at?: any | null, plan_review_extraction_documents: Array<{ __typename?: 'plan_review_extraction_documents', id: any, file_name: string, file_url: string, file_size_bytes?: any | null, mime_type: string }>, plan_review_requirement_candidates: Array<{ __typename?: 'plan_review_requirement_candidates', id: any, requirement_type: string, category_id?: any | null, code?: string | null, title: string, description: string, applicable_codes?: any | null, source?: string | null, section?: string | null, default_severity?: string | null, required: boolean, sort_order: number, source_quote?: string | null, page_number?: number | null, confidence?: any | null, match_kind: string, resolution: string, imported_requirement_id?: any | null, category_record?: { __typename?: 'plan_review_categories', id: any, name: string } | null, document?: { __typename?: 'plan_review_extraction_documents', id: any, file_name: string } | null, matched_requirement?: { __typename?: 'plan_review_requirements', id: any, code?: string | null, title: string, description: string, jurisdiction_id: any } | null, plan_review_candidate_code_sections: Array<{ __typename?: 'plan_review_candidate_code_sections', code_section_id: any, citation_text?: string | null, code_section: { __typename?: 'code_sections', id: any, section_number: string, title?: string | null, page_number?: number | null, code_book: { __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null, book_type: string, source_file_url?: string | null } } }>, plan_review_candidate_submission_types: Array<{ __typename?: 'plan_review_candidate_submission_types', submission_type_id: any, submission_type: { __typename?: 'plan_review_submission_types', id: any, name: string } }> }> } | null };


export const GetPlanReviewExtractionDocument = gql`
    subscription getPlanReviewExtraction($id: uuid!) {
  plan_review_requirement_extractions_by_pk(id: $id) {
    id
    jurisdiction_id
    status
    instructions
    candidate_count
    imported_count
    error_message
    model_name
    created_at
    completed_at
    plan_review_extraction_documents(order_by: {sort_order: asc}) {
      id
      file_name
      file_url
      file_size_bytes
      mime_type
    }
    plan_review_requirement_candidates(order_by: {sort_order: asc}) {
      id
      requirement_type
      category_id
      category_record {
        id
        name
      }
      code
      title
      description
      applicable_codes
      source
      section
      default_severity
      required
      sort_order
      source_quote
      page_number
      document {
        id
        file_name
      }
      confidence
      match_kind
      resolution
      imported_requirement_id
      matched_requirement {
        id
        code
        title
        description
        jurisdiction_id
      }
      plan_review_candidate_code_sections(order_by: {sort_order: asc}) {
        code_section_id
        citation_text
        code_section {
          id
          section_number
          title
          page_number
          code_book {
            id
            abbreviation
            edition_year
            book_type
            source_file_url
          }
        }
      }
      plan_review_candidate_submission_types {
        submission_type_id
        submission_type {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewExtractionSubscription__
 *
 * To run a query within a React component, call `useGetPlanReviewExtractionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewExtractionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewExtractionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanReviewExtractionSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPlanReviewExtractionSubscription, GetPlanReviewExtractionSubscriptionVariables> & ({ variables: GetPlanReviewExtractionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPlanReviewExtractionSubscription, GetPlanReviewExtractionSubscriptionVariables>(GetPlanReviewExtractionDocument, options);
      }
export type GetPlanReviewExtractionSubscriptionHookResult = ReturnType<typeof useGetPlanReviewExtractionSubscription>;
export type GetPlanReviewExtractionSubscriptionResult = Apollo.SubscriptionResult<GetPlanReviewExtractionSubscription>;